const Services = () => {
  return (
    <section id="services" className="services section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        {/* <h2>Services</h2> */}
        <p><span>I Nostri Servizi</span></p>
        <small>Soluzioni digitali avanzate per sicurezza, aerospazio, intelligenza artificiale, settore civile e agricoltura.</small>
      </div>{/* End Section Title */}
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={100}>
            <div className="service-item position-relative">
                <img src="img/satellite-icon.png" alt="satellite" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>Monitoraggio Satellitare & Droni</h3>
              </a>
              <p>Analisi geospaziale e sorveglianza UAS/ROV</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={200}>
            <div className="service-item position-relative">
              <img src="img/brain-icon.png" alt="brain" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>Intelligenza Artificiale</h3>
              </a>
              <p>Modelli AI operativi e certificabili</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={300}>
            <div className="service-item position-relative">
              <img src="img/shield-icon.png" alt="shield" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>Cybersecurity Engine</h3>
              </a>
              <p>Rilevamento anomalie in tempo reale</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={400}>
            <div className="service-item position-relative">
              <img src="img/gps-icon.png" alt="gps" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>FF-App</h3>
              </a>
              <p>Gestione forze e risorse sul territorio</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={500}>
            <div className="service-item position-relative">
              <img src="img/video-icon.png" alt="video" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>Videoconferenza Sicura</h3>
              </a>
              <p>Comunicazioni cifrate end-to-end</p>
            </div>
          </div>{/* End Service Item */}
          <div className="col-lg-6 col-md-6" data-aos="fade-up" data-aos-delay={600}>
            <div className="service-item position-relative">
              <img src="img/block-icon.png" alt="block" className="mb-3" />
              <a href="#services" className="stretched-link">
                <h3>Blockchain</h3>
              </a>
              <p>Tracciabilità e audit trail immutabili</p>
            </div>
          </div>{/* End Service Item */}
        </div>
      </div>
    </section>
  );
}
export default Services;